import { get, post, getSign } from '../utils/http'

class Auth {
  async requestTokenFromServe(code) {
    const res = await post('/api/auth/v1/token/checkPublicNum', { code })
    return res.data
  }

  async login(code) {
    const res = await get(
      '/api/user/userProfile/check/bindPublic',
      {},
      { code }
    )
    return res.data
  }

  // async register(
  //   data = {
  //     mobile: '',
  //     smsRegCode: '',
  //     password: '',
  //     joinTraderId: '',
  //     shareUserId: '',
  //     src: 'oa'
  //   }
  // ) {
  //   const res = await post('/api/auth/v1/token/userWebReg', data)
  //   return res.data
  // }

  // //有wechatCode 注册使用 v2是新版接口
  async register(
    data = {
      code: '',
      mobile: '',
      smsRegCode: '',
      joinTraderId: '',
      shareUserId: '',
      registerSource: 6 //标记是H5注册
    }
  ) {
    data.registerSource = data.registerSource || 6 //没有传registerSource就默认是6
    const res = await post('/api/auth/v1/token/publicNumLogin/v2', data)
    return res.data
  }

  // async sendSMSCode(mobile, imgCode) {
  //   const res = await get(`
  //   /api/user/v1/getSmsCode?mobile=${mobile}&imgCode=${imgCode}
  //   `)
  //   return res.data
  // }

  // 获取验证码
  async sendSMSCode(mobile) {
    const res = await getSign(`
    /api/user/v1/getH5SmsCode/${mobile}
    `)
    return res.data
  }

  async getUserState(data) {
    const res = await post('/api/auth/v1/token/loginByCode/v2', data)
    return res
  }

  //没有wechatCode 注册使用 v2是新版接口
  async loginByCode(
    data = {
      mobile: '',
      smsRegCode: '',
      joinTraderId: '',
      shareUserId: '',
      src: 'oa',
      registerSource: 6 //标记是H5注册
    }
  ) {
    data.registerSource = data.registerSource || 6
    const res = await post(`/api/auth/v1/token/loginByCode/v2`, data)
    return res.data
  }
  // 用户是否已注销
}

export default new Auth()
